import React from 'react';
import { Container, Typography, Box, Paper, Grid } from '@mui/material';
import { VerifiedUser as ComplianceIcon } from '@mui/icons-material';

const ComplianceAssessments: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: '#003366', mb: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
          <ComplianceIcon sx={{ fontSize: 40 }} />
          Compliance & Assessments
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Track compliance status and governance maturity
        </Typography>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" sx={{ mb: 2, color: '#003366', fontWeight: 600 }}>
              Compliance Status
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              • DHS Data Governance Charter: Aligned
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              • Federal Data Strategy: In Progress
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              • Data Privacy Regulations: Compliant
            </Typography>
            <Typography variant="body2" color="text.secondary">
              • Security Standards: Under Review
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" sx={{ mb: 2, color: '#003366', fontWeight: 600 }}>
              Recent Assessments
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              • Governance Maturity Assessment - Q4 2025
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              • Data Quality Audit - October 2025
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              • Compliance Review - September 2025
            </Typography>
            <Typography variant="body2" color="text.secondary">
              • Risk Assessment - August 2025
            </Typography>
          </Paper>
        </Grid>
      </Grid>

      <Paper sx={{ p: 4, mt: 3, textAlign: 'center', background: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)', border: '2px dashed #003366' }}>
        <Typography variant="h5" sx={{ mb: 2, color: '#003366', fontWeight: 600 }}>
          🚧 Compliance Management System Coming Soon
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Features: Compliance dashboard, Assessment tools, Audit trails, Risk management, Reporting.
        </Typography>
      </Paper>
    </Container>
  );
};

export default ComplianceAssessments;
